var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95 6.577H.77v13.327h4.18V6.577ZM16.255 6.287c-.154-.019-.318-.028-.482-.038a4.877 4.877 0 0 0-4.121 1.887c-.125.164-.183.26-.183.26V6.615H7.473v13.327h4.179v-6.259c0-.905-.068-1.868.385-2.697.385-.693 1.078-1.04 1.858-1.04 2.311 0 2.36 2.09 2.36 2.283V20h4.179v-8.696c0-2.975-1.512-4.728-4.18-5.017ZM2.86 4.853A2.427 2.427 0 1 0 2.86 0a2.427 2.427 0 0 0 0 4.853Z",
    fill: "currentColor"
  })));
};
export default SvgLinkedin;